<smrts-dialog [title]="title" [hasFootnote]="true">

  <form [formGroup]="formulario">
    <div class="custom-table">

      <div class="custom-table-row">
        <div class="custom-table-col two-column-width">
          <app-generic-autocomplete class="margin-bottom" [items]="bancoOrigemList" displayField="label"
            label="Banco de Origem" inputId="bancoOrigem" formControlName="bancoOrigem">
          </app-generic-autocomplete>
        </div>
      </div>

      @if (!isCartao) {
        <div class="custom-table-row">
          <div class="custom-table-col one-column-width">
            <p-floatlabel variant="on">
              <p-inputNumber inputId="saldo" mode="currency" currency="BRL" formControlName="saldo" fluid></p-inputNumber>
              <label>Saldo do banco</label>
            </p-floatlabel>
          </div>
          <div class="custom-table-col one-column-width">
            <p-floatlabel variant="on">
              <p-datepicker [showIcon]="true" formControlName="dataSaldo" [fluid]="true" dateFormat="dd/mm/yy" appendTo="body"/>
              <label>Data do Saldo</label>
            </p-floatlabel>
          </div>
        </div>
      }


      <div class="custom-table-row">
        <div class="custom-table-col two-column-width">
          <p-floatlabel variant="on">
            <p-datepicker [showIcon]="true" formControlName="dataLancamentoConciliado" [fluid]="true" dateFormat="dd/mm/yy" appendTo="body"/>
            <label>Data do ultimo lançamento conciliado</label>
          </p-floatlabel>
        </div>
      </div>

    </div>
  </form>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="salvarClick()">
      Salvar
    </button>
  </div>
</smrts-dialog>